import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import NewsCard from '@/components/feature/NewsCard';
import { getLatestNews } from '@/utils/content';

export default function NewsSection() {
  const items = getLatestNews(4);
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-12">
      <SectionTitle
        icon="ri-newspaper-line"
        title="最新赛事资讯"
        subtitle="赛事动态、排名分析与选手新闻持续更新"
        action={
          <Link
            to="/category/news"
            className="text-sm font-medium text-primary-700 hover:text-primary-800 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="flex flex-col gap-4">
        {items.map((item) => (
          <NewsCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}